import { IPromise, IScope } from 'angular'
import { $q } from '../../../ng-compat/imports'

interface CashDiscountingModalOptions {
  amountTendered: number
  balance: number
  cashDiscountedBalance: number
}

export class CashDiscountingModalController {
  public readonly close: () => void
  public readonly amountTendered: number
  public readonly balance: number
  public readonly cashDiscountedBalance: number
  private readonly internalClose: (val: IPromise<number>) => void

  constructor(
    $scope: IScope,
    close: (val: IPromise<number>) => void,
    public readonly options: CashDiscountingModalOptions,
    private readonly vdEscapeStack: any
  ) {
    'ngInject'

    this.internalClose = close
    this.close = () => this.internalClose($q.reject())

    this.amountTendered = options.amountTendered
    this.balance = options.balance
    this.cashDiscountedBalance = options.cashDiscountedBalance

    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
